"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaults = void 0;
const constants_1 = require("./constants");
const getDefaults = (locale) => {
    const locale_key = locale && locale in constants_1.LOCALE_DEFAULTS_BY_LOCALE ? locale : constants_1.DEFAULT_LOCALE;
    return constants_1.LOCALE_DEFAULTS_BY_LOCALE[locale_key];
};
exports.getDefaults = getDefaults;
//# sourceMappingURL=defaults.js.map